export default __webpack_public_path__ + "static/media/app-connectivity.90328a4e.svg";